import { connectRedux } from '@om1/platform-utils'
import { cohortBlocksEditActions } from '../../../state'
import { ObservationPeriodDialogComponent } from './ObservationPeriodDialogComponent'

export function createObservationPeriodDialogComponent<TState extends {}>() {
    return connectRedux(ObservationPeriodDialogComponent, (state: TState) => state, cohortBlocksEditActions)
}

export type DataTypesDialog = ReturnType<typeof createObservationPeriodDialogComponent>
